export default __webpack_public_path__ + "static/media/customer-ic-balance-card.366b2990.svg";